import styled from 'styled-components';
import dateFormat, { masks } from 'dateformat';
import SessionToggle from '../PlayerChartCards/SessionToggle';
import AssistanceDetails from './AssistanceDetails';
import Measurements from './Measurements';

import MeasurementFilter from '../../services/MeasurementFilter';
import NoSessions from '../NoSessions';

const SessionHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  padding: 32px max(10%, 148px) 24px;
  align-items: center;
`;

const Heading = styled.h3(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.larger};
    color: ${color.grayscale[0]};
    font-weight: ${type.weight.bold};
    margin: 0 25px 0 0;
    flex-shrink: 1;
  `;
});

const Date = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: 1.375rem;
    font-weight: ${type.weight.normal};
    color: ${color.grayscale[0]};
    flex-shrink: 1;
  `;
});

const ToggleWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  padding-left: 1rem;
`;

const Card = styled.div(({ theme }) => {
  const { color, shadow } = theme;

  return `
    background-color: ${color.grayscale[1000]};
    border-radius: 16px;
    box-shadow: ${shadow.dialog};
    padding: 38px 32px;
    width: max(89%, 1284px);
    margin: 0 auto;
  `;
});

const Assistance = styled(AssistanceDetails)`
  margin: 0 auto;
  padding: 0 max(25%, 332px);
`;

const measurementFilter = new MeasurementFilter();

const PlayerSession = ({ sessionData, toggleCallback, activeSession }) => {
  const hasSession = sessionData.success === false ? false : true;
  const { date, duration, measurement, assistance, durationTitle } = sessionData;
  const filteredMeasurement = hasSession ? measurementFilter.filterMeasurementData(measurement) : null;

  const handleTabClick = (session) => {
    const sessionId = parseInt(session);

    toggleCallback(sessionId);
  };

  return (
    <div>
      <SessionHeader>
        <Heading>Last session's data</Heading>
        <Date>Date: {dateFormat(date, masks.shortDate)}</Date>

        <ToggleWrapper>
          <SessionToggle
            options={[
              {
                label: 'MY SESSIONS',
                value: 1,
              },
              {
                label: 'ALL SESSIONS',
                value: 0,
              },
            ]}
            callback={handleTabClick}
            selected={activeSession}
          />
        </ToggleWrapper>
      </SessionHeader>

      {sessionData.success === false ? (
        <NoSessions callback={toggleCallback} />
      ) : (
        <Card>
          <Measurements duration={duration} measurement={filteredMeasurement} durationTitle={durationTitle} />
          <Assistance inputs={assistance} />
        </Card>
      )}
    </div>
  );
};

export default PlayerSession;
